import React from 'react';

const ResponsiveTable = ({ columns, data, renderRow, className = '' }) => {
  return (
    <>
      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto">
        <table className={`w-full ${className}`}>
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              {columns.map((col) => (
                <th key={col.key} className="text-left px-6 py-3 font-semibold text-slate-900">
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-6 py-8 text-center text-slate-600">
                  <p>No data found</p>
                </td>
              </tr>
            ) : (
              data.map((row, idx) => renderRow(row, idx))
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4">
        {data.length === 0 ? (
          <div className="text-center py-8 text-slate-600">
            <p>No data found</p>
          </div>
        ) : (
          data.map((row, idx) => (
            <div key={idx} className="bg-white rounded-lg border border-slate-200 p-4 shadow-sm">
              {renderRow(row, idx, true)}
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default ResponsiveTable;
